/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SheetGoogleTemplateCopiedRange'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./SheetGoogleTemplateCopiedRange'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetGoogleTemplateCopiedRangeSettings = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SheetGoogleTemplateCopiedRange);
  }
}(this, function(ApiClient, SheetGoogleTemplateCopiedRange) {
  'use strict';




  /**
   * The SheetGoogleTemplateCopiedRangeSettings model module.
   * @module model/SheetGoogleTemplateCopiedRangeSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>SheetGoogleTemplateCopiedRangeSettings</code>.
   * @alias module:model/SheetGoogleTemplateCopiedRangeSettings
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>SheetGoogleTemplateCopiedRangeSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SheetGoogleTemplateCopiedRangeSettings} obj Optional instance to populate.
   * @return {module:model/SheetGoogleTemplateCopiedRangeSettings} The populated <code>SheetGoogleTemplateCopiedRangeSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('SourceTemplateID')) {
        obj['SourceTemplateID'] = ApiClient.convertToType(data['SourceTemplateID'], 'Integer');
      }
      if (data.hasOwnProperty('GoogleConfigurationIDs')) {
        obj['GoogleConfigurationIDs'] = ApiClient.convertToType(data['GoogleConfigurationIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('Ranges')) {
        obj['Ranges'] = ApiClient.convertToType(data['Ranges'], [SheetGoogleTemplateCopiedRange]);
      }
    }
    return obj;
  }

  /**
   * @member {Integer} SourceTemplateID
   * @default 0
   */
  exports.prototype['SourceTemplateID'] = 0;
  /**
   * @member {Array.<Integer>} GoogleConfigurationIDs
   */
  exports.prototype['GoogleConfigurationIDs'] = undefined;
  /**
   * @member {Array.<module:model/SheetGoogleTemplateCopiedRange>} Ranges
   */
  exports.prototype['Ranges'] = undefined;



  return exports;
}));


